<div class="cliente-dashboard">
    <!-- Cadastro Situação -->
    <div class="row mb-4">
        <div class="col-12 pl-0">
            <sgt-cliente-cadastro-situacao-chart
                #cadastroSituacaoChart>
            </sgt-cliente-cadastro-situacao-chart>
        </div>
    </div>

    <!-- Segmentos -->
    <div class="row mb-4">
        <div class="col-12">
            <sgt-cliente-segmento-chart
                #segmentoChart>
            </sgt-cliente-segmento-chart>
        </div>
    </div>
</div>
